import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Brochure } from '../models/brochure.model';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BrochureService {
    apiUrl = environment.apiUrl;
    brochures: Brochure;

    constructor(private http: HttpClient) { }

    getAll(): Observable<Brochure> {
        return this.http.get(`${this.apiUrl}/brochures`).pipe(
            map((res) => {
                this.brochures = res['data'];
                return this.brochures;
            }),
        catchError(this.handleError));
    }

    getStageAndPrepa(): Observable<Brochure> {
        const params = new HttpParams().set('type', 'stage-prepa');
        return this.http.get(`${this.apiUrl}/brochures`, { params: params }).pipe(
            map((res) => {
                this.brochures = res['data'];
                return this.brochures;
            }),
        catchError(this.handleError));
    }

    getB2b(): Observable<Brochure> {
        const params = new HttpParams().set('type', 'b2b');
        return this.http.get(`${this.apiUrl}/brochures`, { params: params }).pipe(
            map((res) => {
                this.brochures = res['data'];
                return this.brochures;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
